import { Link } from 'react-router-dom';
import { comics, recommendedComicIds } from '@/mocks/comics';
import ComicCard from '@/components/feature/ComicCard';

export default function RecommendedSection() {
  const recommended = recommendedComicIds
    .map((id) => comics.find((c) => c.id === id))
    .filter(Boolean) as NonNullable<ReturnType<typeof comics.find>>[];

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            编辑精选
          </h2>
          <p className="text-sm text-foreground-500 mt-2">我们为你精心挑选的优质作品</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-5">
          {recommended.map((comic, idx) => (
            <div key={comic.id} className="flex flex-col">
              <ComicCard comic={comic} />
              {idx === 0 && (
                <Link
                  to={`/comic/${comic.id}`}
                  className="mt-3 px-5 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-medium text-center whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
                >
                  立即阅读
                </Link>
              )}
              {idx > 0 && (
                <Link
                  to={`/comic/${comic.id}`}
                  className="mt-3 px-5 py-2.5 rounded-full border border-foreground-300 text-foreground-700 text-sm font-medium text-center whitespace-nowrap hover:bg-foreground-100 transition-colors cursor-pointer"
                >
                  加入书架
                </Link>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}